import { Stack, type StackProps } from '@mantine/core';
import { useElementSize } from '@mantine/hooks';
import { useEffect, useState } from 'react';

export const HeightFittedStack = ({ children, ...props }: StackProps) => {
    const [maxHeight, setMaxHeight] = useState<number | string>('100%');
    const { ref, height } = useElementSize();

    useEffect(() => {
        if (!maxHeight) {
            setMaxHeight(height);
        }
    }, [height]);

    return (
        <div
            ref={ref}
            style={{ height: '100%', width: '100%' }}
        >
            <Stack
                h={'100%'}
                w={'100%'}
                mah={maxHeight}
                {...props}
            >
                {children}
            </Stack>
        </div>
    );
};
